module.exports = __webpack_public_path__ + "img/mypage_banner_04.aa082fc1.png";